// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { Checkbox, FormControlLabel, Tooltip, Typography } from '@mui/material';
import { ChangeEventHandler } from 'react';

interface Props {
  /**
   * The tooltip to display when hovering over the control.
   */
  tooltip: string;

  /**
   * The current value of the control.
   */
  isChecked: boolean;

  /**
   * A callback fired when the value of the control changes.
   */
  onChange: (isChecked: boolean) => void;
}

/**
 * A controlled component that allows the user to toggle the display of
 * archived entities.
 */
export function ArchiveFilterControl(props: Props) {
  const handleChangeArchivedFilter: ChangeEventHandler<HTMLInputElement> = (
    event
  ) => {
    props.onChange(event.target.checked);
  };

  return (
    <Tooltip arrow placement="top" title={props.tooltip}>
      <FormControlLabel
        label={<Typography variant="body2">Archived</Typography>}
        control={
          <Checkbox
            size="small"
            checked={props.isChecked}
            onChange={handleChangeArchivedFilter}
          />
        }
      />
    </Tooltip>
  );
}
